import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Blocks from '../blocks';

const propTypes = {
    blocks: PropTypes.array.isRequired,
};

const defaultProps = {
    blocks: [],
};

class Block extends Component {

    constructor(props) {
        super(props);
        this.renderBlock = this.renderBlock.bind(this);
    }

    // eslint-disable-next-line class-methods-use-this
    renderBlock(block, index) {
        const BlockComponent = Blocks[block.type || 'text'];
        return (
            <div key={`block_${block.id || index}`} className="block">
                <BlockComponent {...block} />
            </div>
        );
    }

    render() {
        const { blocks } = this.props;

        return (
            <div className="container blocks-container">
                { blocks.map(this.renderBlock) }
            </div>
        );
    }
}

Block.propTypes = propTypes;
Block.defaultProps = defaultProps;

export default Block;



// WEBPACK FOOTER //
// ./components/partials/Block.jsx